import { settingsGuideEntity } from "../../domain/entitites/settings_guide";
import http from "../../../../plugins/http-common"

export const HttpSettingsGuideRepository = {
  model: settingsGuideEntity,

  async save(settings_guide) {    
    const res = await http.post('settings-guide/save', settings_guide);

    return res.data;
  },
  async get_settings_guide(id){
    const res = await http.get('settings-guide/load/' + id);
    
    return res.data
  }
};